/**
 * Browser (IIFE/CDN) entry — Cognito. Built to foundation-sdk.browser.global.js,
 * the unpkg/jsdelivr default.
 *
 * Registers the same factory the `foundation-sdk/cognito` npm entry exports. Do
 * not re-implement the provider here: this file previously held a hand-copied
 * variant that drifted and silently shipped without confirmSignUp, dead-ending
 * Cognito's default CONFIRM_SIGN_UP signup flow on the CDN build.
 *
 * Register explicitly rather than relying on auth-cognito's own auto-registration
 * side effect. package.json "sideEffects" only whitelists the built ./dist/auth-*
 * paths, so esbuild considers the source module side-effect-free and drops a
 * bare `import './auth-cognito'` — taking Amplify and the whole provider with it.
 */
import { registerAuthProvider } from './auth'
import { cognitoAuth } from './auth-cognito'

registerAuthProvider('cognito', cognitoAuth)

export { createFoundation } from './foundation'
